import { Utils } from '../utils';
import domainsConfigs from './domainsConfigs';

const routeConfigs = [...domainsConfigs];

const routes = [...Utils.generateRoutesFromConfigs(routeConfigs, null)];
export default routes;
